export const ERROR_MESSAGES: Record<string, string> = {
  // Sales Nav errors
  'SALES_NAV_NO_RESULTS':
    'Sales Navigator returned no results. Try adjusting your search criteria or keywords.',
  'SALES_NAV_NO_RESULTS_AFTER_LOCATION_FILTER':
    'Location filter removed all profiles. Try broader location terms or disable location filtering.',
  'SALES_NAV_SEARCH_FAILED':
    'Sales Navigator search failed. Check your Unipile account connection and try again.',

  // OpenAI/AI errors
  'OPENAI_API_ERROR':
    'AI analysis failed. Check API key configuration and try again.',
  'OPENAI_RATE_LIMIT':
    'AI service rate limit reached. Please wait a few minutes and try again.',
  'OPENAI_TIMEOUT':
    'AI analysis timed out. The task may be too complex, try simplifying your criteria.',

  // Unipile/LinkedIn errors
  'UNIPILE_AUTH_FAILED':
    'LinkedIn authentication failed. Please reconnect your LinkedIn account in settings.',
  'UNIPILE_SALES_NAV_AUTH_FAILED':
    'Sales Navigator session could not be refreshed. Reconnect the LinkedIn account in Unipile and try again.',
  'UNIPILE_RATE_LIMIT':
    "LinkedIn rate limit reached. LinkedIn has temporary usage limits - wait 30 minutes and try again.",
  'UNIPILE_CONNECTION_ERROR':
    'Unable to connect to LinkedIn. Check your internet connection and try again.',

  // Task configuration errors
  'INVALID_TASK_CONFIG':
    'Task configuration is invalid. Please check all required fields are filled correctly.',
  'MISSING_SALES_NAV_URL':
    'Sales Navigator URL is required. Please provide a valid search URL.',
  'INVALID_CLIENT':
    'Client configuration is invalid or missing. Please check client setup.',

  // Generic errors
  'TASK_CANCELLED':
    'Task was cancelled by user.',
  'TASK_TIMEOUT':
    'Task exceeded maximum runtime. Try reducing the scope of your search.',
  'UNKNOWN_ERROR':
    'An unexpected error occurred. Please try again or contact support.',
}

export function getErrorMessage(error: string | null | undefined, fallback = 'Task failed'): string {
  if (!error) return fallback

  // Try exact match first
  if (ERROR_MESSAGES[error]) return ERROR_MESSAGES[error]

  // Try partial matching for error codes with prefixes/suffixes
  const errorUpper = error.toUpperCase()
  for (const [key, message] of Object.entries(ERROR_MESSAGES)) {
    if (errorUpper.includes(key.toUpperCase())) {
      return message
    }
  }

  // If error message contains common patterns, provide context
  if (errorUpper.includes('TIMEOUT')) {
    return ERROR_MESSAGES['TASK_TIMEOUT']
  }
  if (errorUpper.includes('RATE') && errorUpper.includes('LIMIT')) {
    return ERROR_MESSAGES['OPENAI_RATE_LIMIT']
  }
  if (errorUpper.includes('AUTH')) {
    return ERROR_MESSAGES['UNIPILE_AUTH_FAILED']
  }

  // Return original error message as fallback
  return error
}
